import { render, staticRenderFns } from "./_websiteplate.vue?vue&type=template&id=b0560c32&scoped=true"
import script from "./_websiteplate.vue?vue&type=script&lang=js"
export * from "./_websiteplate.vue?vue&type=script&lang=js"
import style0 from "./_websiteplate.vue?vue&type=style&index=0&id=b0560c32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0560c32",
  null
  
)

export default component.exports